<template>
  <div :class="[inputContainerClass, { 'is-invalid': !isValid, 'is-empty': isEmpty }]">
    <slot></slot>
    <p v-if="!isValid && message" :class="['input-error-message']" role="alert" v-html="message"></p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'input-validator',
  props: {
    inputContainerClass: {
      type: String,
      default: 'form-group',
    },
    value: {
      default: undefined,
    },
    validator: {
      type: Function,
      default: undefined,
    },
    liveValidation: {
      type: Boolean,
      default: true,
    },
    message: {
      type: String,
      default: undefined,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isValid: true,
      isEmpty: true,
    };
  },
  updated() {
    this.onUserInteraction();
  },
  methods: {
    validate() {
      if (typeof this.validator === 'function') {
        this.isValid = this.validator(this.value);
      } else {
        this.isValid = !this.required || (this.required && !this.isEmpty);
      }
    },
    onUserInteraction() {
      if (typeof this.value === 'undefined' || this.value === '') {
        this.isEmpty = true;
      } else {
        this.isEmpty = false;
      }

      if (this.liveValidation) {
        this.validate();
      }
    },
  },
});
</script>
